module.exports = __webpack_public_path__ + "img/symbol_6.0c657de3.png";